import { Box } from "@mui/material";
import { Toggle } from "pepsico-ds";

const StatusConfiguration = ({ status, setStatus }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <Toggle
        label="Status"
        className="flex flex-row gap-1"
        onUpdate={(value) => {
          setStatus(value);
        }}
        checked={status}
        size="medium"
        value={status ? "Active" : "Inactive"}
        variant="horizontal"
      />
    </Box>
  );
};

export default StatusConfiguration;
